import React, { useContext } from 'react';
import { IFirmwareContext, FirmwareContext } from '../../../firmwareState/firmwareContext';
import SearchField from 'components/SearchField/SearchField';

const Search: React.FC = () => {
	const { changeSearchString, searchString, firmware } = useContext<IFirmwareContext>(FirmwareContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={firmware.count ? 800 : undefined}
		/>
	);
};

export default Search;
